// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2189E","title":"AfterBackImages_title__2S2K7","images":"AfterBackImages_images__3Wrip"};